import { gql, QueryHookOptions, useQuery } from '@apollo/client';

const QUERY = gql`
  query getRoles {
    getRoles {
      id
      name
    }
  }
`;

export type Role = {
    id: string;
    name: string;
};

export type Response = {
    getRoles: Role[];
};

export const useGetRolesQuery = (options?: QueryHookOptions<Response>) =>
    useQuery<Response>(QUERY, options);
